import { render, staticRenderFns } from "./TableLastShipMail.vue?vue&type=template&id=62fa87d1&scoped=true&"
import script from "./TableLastShipMail.vue?vue&type=script&lang=js&"
export * from "./TableLastShipMail.vue?vue&type=script&lang=js&"
import style0 from "./TableLastShipMail.vue?vue&type=style&index=0&id=62fa87d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa87d1",
  null
  
)

export default component.exports